// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ou3N5","label":"styles_label__1aL1V"};